import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { fetchAsaasPaymentsOverview, refundAsaasPayment } from "./thunks";

interface OverviewPagination {
  total?: number;
  per_page?: number;
  current_page?: number;
  last_page?: number;
  has_more?: boolean;
}

interface OverviewState {
  data: any[];
  pagination: OverviewPagination | null;
  applied_filters: Record<string, any>;
  loading: boolean;
  error: string | null;
  startedAt?: number | null;
  lastFetchedAt?: number | null;
}

interface AsaasPaymentsState {
  overview: OverviewState;
  mutating: boolean;
}

const initialState: AsaasPaymentsState = {
  overview: {
    data: [],
    pagination: null,
    applied_filters: {},
    loading: false,
    error: null,
    startedAt: null,
    lastFetchedAt: null,
  },
  mutating: false,
};

const AsaasPaymentsSlice = createSlice({
  name: "asaasPayments",
  initialState,
  reducers: {
    forceClearOverviewLoading: (state) => {
      if (state.overview.loading) state.overview.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAsaasPaymentsOverview.pending, (state) => {
        state.overview.loading = true;
        state.overview.error = null;
        state.overview.startedAt = Date.now();
      })
      .addCase(
        fetchAsaasPaymentsOverview.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.overview.loading = false;
          state.overview.lastFetchedAt = Date.now();

          const payload = action.payload || {};
          const container = payload.content ?? payload.data ?? payload;

          let list: any[] = [];
          let pagination: any = null;
          let applied_filters: any = {};

          if (Array.isArray(container)) {
            list = container;
          } else if (container && typeof container === "object") {
            if (Array.isArray(container.data)) list = container.data;
            pagination = container.pagination ?? container.meta ?? null;
            applied_filters = container.applied_filters ?? {};
          }

          state.overview.data = Array.isArray(list) ? list : [];
          state.overview.pagination = pagination;
          state.overview.applied_filters = applied_filters;
        },
      )
      .addCase(fetchAsaasPaymentsOverview.rejected, (state, action: any) => {
        state.overview.loading = false;
        state.overview.lastFetchedAt = Date.now();
        state.overview.error =
          action.payload?.message || "Erro ao carregar pagamentos";
      })
      .addCase(refundAsaasPayment.pending, (state) => {
        state.mutating = true;
      })
      .addCase(
        refundAsaasPayment.fulfilled,
        (state, action: PayloadAction<any>) => {
          state.mutating = false;
          toast.success("Estorno efetuado");
        },
      )
      .addCase(refundAsaasPayment.rejected, (state, action: any) => {
        state.mutating = false;
        toast.error(action.payload?.message || "Erro ao estornar pagamento");
      });
  },
});

export const { forceClearOverviewLoading } = AsaasPaymentsSlice.actions;
export default AsaasPaymentsSlice.reducer;
